<template>
  <div class="loading-page-container" :class="{ 'full-page': isFullPage }">
    <loading-spinner v-if="isLoading" />
    <success-loading v-else-if="successLoading" />
  </div>
</template>

<script>
import LoadingSpinner from './LoadingSpinner.vue';
import SuccessLoading from './SuccessLoading.vue';

export default {
  name: 'LoadingPage',
  props: {
    isFullPage: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isLoading: true,
    successLoading: false,
  }),
  components: {
    LoadingSpinner,
    SuccessLoading,
  },
  methods: {
    async finishLoading({ success }) {
      this.isLoading = false;
      this.successLoading = success;
    },
  },
};
</script>

<style lang="scss" scoped>
  .loading-page-container {
    width: 100%;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (min-width: $breakpoint-large) {
      min-height: auto;
      margin-top: 96px;
      margin-bottom: 120px;
    }

    &.full-page {
      @media (min-width: $breakpoint-large) {
        min-height: 100vh;
        margin-top: 0px;
        margin-bottom: 0px;
      }
    }
  }
</style>
